
export default {
  name: 'BlogFilterTypes',
  props: {
    data: {
      type: Array,
      default: () => ([]),
    },
    categoryActive: {
      type: Boolean,
      default: true,
    },
    authorActive: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      // isCategoryActive: this.categoryActive,
      // isAuthorActive: this.authorActive,
    }
  },
  mounted() {
    if(this.$store?.state?.blog?.filters?.activeType === 'author') {
      this.setAuthorActive()
      this.$store.commit('blog/setActiveType', 'AUTHOR')
    }
  },
  computed: {
    showCategory() {
      return !this.isAuthorPage()
    },
    isTagActive() {
      return this.$store.state.blog.filters.activeType === 'tag'
    },
    isAuthorActive() {
      return this.$store.state.blog.filters.activeType === 'author'
    }
  },
  methods: {
    setTagActive() {
      this.$store.commit('blog/setActiveType', 'TAG')
    },
    setAuthorActive() {
      this.$store.commit('blog/setActiveType', 'AUTHOR')
    },
    isAuthorPage() {
      if(this.$route?.path?.includes("author")) {
        // this.toggleTypes()
        return true
      }
      return false
    },
    // setAuthorActive() {
    //   this.isCategoryActive = false
    //   this.isAuthorActive = true
    //   this.$emit('update:categoryActive', this.iscategoryActive)
    //   this.$emit('update:authorActive', this.isAuthorActive)
    // },

    // toggleTypes(status) {
    //   if (!status) {
    //     this.handleCategoryType()
    //     this.handleAuthorType()
    //   }
    // },
    // handleCategoryType() {
    //   this.isCategoryActive = !this.isCategoryActive; 
    //   this.$emit('update:categoryActive', this.isCategoryActive)
    //   this.$store.commit('blog/setActiveType', 'TAG')
    // },
    // handleAuthorType() {
    //   this.isAuthorActive = !this.isAuthorActive;
    //   this.$emit('update:authorActive', this.isAuthorActive)
    //   this.$store.commit('blog/setActiveType', 'AUTHOR')
    // },
  },
}
